import S3 from 'react-aws-s3';
//  
import { 
    BUCKET_NAME, 
    ACCESS_KEY_ID, 
    SECRET_ACCESS_KEY
} from '../config/s3Config';

export const s3Upload = (file = '',fileName = '') => {
	const config = {
		bucketName: BUCKET_NAME,
		region: 'us-east-1',
		accessKeyId: ACCESS_KEY_ID,
		secretAccessKey: SECRET_ACCESS_KEY,
		s3Url: 'https://unity-61a0c.s3.amazonaws.com/'
	};

	const ReactS3Client = new S3(config);

	return ReactS3Client.uploadFile(file, fileName);
};
